import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, Typography } from '@mui/material';
import { ContainerArbitrator } from '../../../ArbitrationObjects/ContainerArbitrator/containerArbitrator';
import { useObjectContainerLink } from '../../../ArbitrationObjects/ContainerArbitrator/useObjectContainerLink';
import { ActionIcons } from '../../../Iconography';
const debug = process.env.REACT_APP_DEBUG && false;
export function CustFolderClickWrapper({ sourceObject, objectTypeId, element }) {
    const { onClick, link } = useObjectContainerLink({ vob: sourceObject });
    const vob = sourceObject;
    debug && console.log('CustFolderClickWrapper has link', link);
    if (vob) {
        return _jsx("span", { onClick, children: element });
    }
    else {
        return element;
    }
}
function showContextMenu(event, groupType, navigationContext, deviceType, domain) {
    event.preventDefault();
    event.stopPropagation();
    navigationContext.setDomain(domain);
    navigationContext.setDeviceType(deviceType);
    navigationContext.setCreateGroupType(groupType);
    navigationContext.setAnchorEl(event.currentTarget);
    navigationContext.setShow((s) => !s);
}
export function handleContextMenu(name, supportedType, navigationContext, deviceType, domain) {
    return (_jsxs("div", { onContextMenu: (event) => showContextMenu(event, supportedType, navigationContext, deviceType, domain), style: { display: 'flex', gap: 8 }, children: [_jsx(Typography, { sx: { flexGrow: 1 }, children: name }), _jsx(IconButton, { size: "small", onClick: (event) => {
                    event.stopPropagation();
                    showContextMenu(event, supportedType, navigationContext, deviceType, domain);
                }, style: { margin: 0, padding: 3 }, children: _jsx(ActionIcons.ContextMenu, { fontSize: "inherit" }) })] }));
}
/** @deprecated unused */
export function leftClickTop(subType, navigate) {
    const containerRoot = ContainerArbitrator.getCanonicalContainer({ type: subType });
    navigate(`/${containerRoot}/Group?supportedType=${subType}`);
}
